export default "__VITE_ASSET__BOlWDMUs__"